<template>
    <div id="list-highlightTypes-component" class="w-full h-full flex flex-col">
        <custom-simple-select
            v-model="option"
            class="w-full"
            label="Tipo de destacado *"
            :options="highlightTypeOptions"
            :disabled="!enabled"
            @change="onInput"
        />
    </div>
</template>

<script>
import { highlightTypes } from "@/common/fields/highlight-types";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "HighlightTypesSelector",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => "highlight",
            type: String,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: ""
    }),
    computed: {
        highlightTypeOptions() {
            return Object.entries(highlightTypes).map(([key, value]) => ({
                label: `${value}`,
                value: key
            }));
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    methods: {
        onInput() {
            this.$emit("change", this.option);
        },
        setInput(value) {
            this.option = value;
        }
    }
};
</script>
